import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absence-reminder__caption" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "absence-reminder__replacement"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_NcUserBubble = _resolveComponent("NcUserBubble")
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")

  return (_openBlock(), _createBlock(_component_NcNoteCard, {
    type: "info",
    class: "absence-reminder"
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_AvatarWrapper, {
        id: $props.userAbsence.userId,
        token: $setup.token,
        name: $props.displayName,
        source: "users",
        size: $setup.AVATAR.SIZE.SMALL,
        "disable-menu": "",
        "disable-tooltip": ""
      }, null, 8, ["id", "token", "name", "size"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString($options.userAbsenceCaption), 1),
      ($options.userAbsencePeriod)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($options.userAbsencePeriod), 1))
        : _createCommentVNode("", true),
      ($props.userAbsence.replacementUserId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString($options.t('spreed', 'Replacement:')), 1),
            (_openBlock(), _createBlock(_component_NcUserBubble, {
              key: $setup.isDarkTheme ? 'dark' : 'light',
              class: "absence-reminder__replacement__bubble",
              title: $options.t('spreed', 'Open conversation'),
              "display-name": $props.userAbsence.replacementUserDisplayName,
              user: $props.userAbsence.replacementUserId,
              onClick: $options.openConversationWithReplacementUser
            }, null, 8, ["title", "display-name", "user", "onClick"]))
          ]))
        : _createCommentVNode("", true),
      ($options.userAbsenceMessage && $data.isTextMoreThanOneLine)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 2,
            class: "absence-reminder__button",
            variant: "tertiary",
            title: !$data.collapsed ? $options.t('spreed', 'Collapse') : $options.t('spreed', 'Expand'),
            "aria-label": !$data.collapsed ? $options.t('spreed', 'Collapse') : $options.t('spreed', 'Expand'),
            onClick: $options.toggleCollapsed
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconChevronUp, {
                class: _normalizeClass(["icon", { 'icon--reverted': !$data.collapsed }]),
                size: 20
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["title", "aria-label", "onClick"]))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        ref: "absenceMessage",
        class: _normalizeClass(["absence-reminder__message", { 'absence-reminder__message--collapsed': $data.collapsed }])
      }, _toDisplayString($options.userAbsenceMessage), 3)
    ]),
    _: 1
  }))
}